<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="pageTitle"
      [canGoBack]="true"
      [customBack]="'concierge'" />
  }
</ng-template>

<ng-container
*ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    <div class="sidebar-search-row">
      <form [formGroup]="searchForm" novalidate action="#">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search'"
          [icon]="'assets/img/search-header.svg'"
          class="header-search" />
      </form>
      @if (type === 'rules') {
        <tidy-small-button
          [text]="'Add Rule'"
          [image]="'assets/img/add-white.svg'"
          [primary]="true"
          (buttonClick)="goToAddRulePage()" />
      }
    </div>

    @for (item of shownItems; track item) {
      <tidy-card>
        @if (type === 'rules') {
          <tidy-row [alignLastItemRight]="true">
            <tidy-text
              [body]="item.description" />
            <tidy-text
              class="link"
              [actionBody]="'Edit'"
              (action)="goToEditRulePage(item)" />
          </tidy-row>
        }
        @if (type === 'suggestions') {
          <tidy-row [alignLastItemRight]="true">
            <tidy-text
              [body]="item.description" />
            <tidy-text
              [actionBody]="'Dismiss'"
              (action)="dismissSuggestion(item)"
              class="link red" />
          </tidy-row>
        }
      </tidy-card>
    }

    @if (items?.length == 0) {
      <tidy-alert>
        <tidy-text
          body="None" />
      </tidy-alert>
    }

  </tidy-wrapper>
</ng-template>

@if (!windowService.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}

